/**
 * Created by Viacheslav Stepanian on 13.04.2026.
 */

const QuestRow = function (row) {
    return Prefab.instantiate(bundles.quests_window.jsons.quest_row_prefab_json, { row });
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    QUESTROW_TITLE: {
        name: "nostroke",
        color: new cc.Color(168, 66, 38),
        size: 50
    }
});